var React = require('react');

function IconBasicCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Templates_icon","d":"M10.652,22.337.534,16.5a.938.938,0,0,1,.937-1.625l9.778,5.644,9.778-5.644a.938.938,0,0,1,.938,1.625L11.842,22.34a1.168,1.168,0,0,1-.592.159A1.187,1.187,0,0,1,10.652,22.337Zm0-4.373L.534,12.123A.937.937,0,1,1,1.472,10.5l9.78,5.643L21.028,10.5a.938.938,0,0,1,.938,1.623L11.842,17.965a1.191,1.191,0,0,1-1.186,0Zm0-4.377L.535,7.748A1.073,1.073,0,0,1,.541,5.887L10.667.152a1.2,1.2,0,0,1,1.167,0L21.958,5.886a1.075,1.075,0,0,1,.009,1.862L11.843,13.59a1.187,1.187,0,0,1-1.191,0ZM2.689,6.825l8.561,4.942,8.562-4.942L11.25,1.978Z","transform":"translate(1.25 1.25)"}));
}

IconBasicCard.defaultProps = {"id":"Templates_Active","data-name":"Templates/Active","width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = IconBasicCard;

IconBasicCard.default = IconBasicCard;
